import React from 'react';

export const ExitText = () => {
  return (
    <p>
      Як евакуаційні виходи можна використовувати дверні отвори, якщо вони ведуть з приміщень: <br /> – безпосередньо
      назовні; <br />– на сходовий майданчик з виходом назовні безпосередньо або через вестибюль; <br />– у прохід або
      коридор з безпосереднім виходом назовні або на сходовий майданчик;
      <br /> – у сусідні приміщення того ж поверху з вогнестійкістю не нижче III ступеня, що не містять виробництв, які
      належать за вибухопожежною та пожежною небезпекою до категорій А, Б і В і мають безпосередній вихід назовні або на
      сходовий майданчик.
    </p>
  );
};
